export class Step1 {
	public intitule = 'stepper.form.simp_an.step1';

	public getspan1 = 'form.simp_an.getspan1';
	public idWeb = 'form.simp_an.getidweb';
	public datePublication = 'form.simp_an.getdatepublication';

	constructor() {}
}
